<template>
  <router-view />
  <DownloadManager />
</template>
 
<script setup lang="ts">
import { onMounted } from 'vue'
import DownloadManager from './components/DownloadManager.vue'
import { useFileStore } from './stores/fileStore'

const fileStore = useFileStore()

onMounted(async () => {
  // Initialize unified file store on app startup
  await fileStore.initialize()
})
</script> 